import { delegationConstants } from '../constants/delegation.constants';

export function delegation(state = {}, action) {
  switch (action.type) {
    case delegationConstants.CREATE_REQUEST:
    case delegationConstants.UPDATE_REQUEST:
    case delegationConstants.FETCH_REQUEST:    
    case delegationConstants.GET_REQUEST:
    case delegationConstants.REMOVE_REQUEST:    
      return {
        ...state,
        loading: true
      };    
    case delegationConstants.CREATE_SUCCESS:
    case delegationConstants.GET_SUCCESS:
    case delegationConstants.UPDATE_SUCCESS:
    return{
      ...state,
      item: action.delegation,
      loading: false
    }    
    case delegationConstants.TEST_SUCCESS:
    case delegationConstants.TEST_FAILURE:    
    return{
      ...state,
      testResult: action.testResult,
      loading: false
    }    
    case delegationConstants.FETCH_SUCCESS:      
      return {
        ...state,
        ...action.delegations,
        loading: false
      };
    case delegationConstants.CREATE_FAILURE:
    case delegationConstants.FETCH_FAILURE:
    case delegationConstants.GET_FAILURE:
    case delegationConstants.REMOVE_FAILURE:
    case delegationConstants.UPDATE_FAILURE:
      return {
        ...state,
        error: action.error
      };   
    default:
      return state
  }
}
